import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { add_to_cart, decrease_cart } from "../../state/cartSlice";
import VegICO from "../../assets/Veg-Logo-2.png";
import NonVegICO from "../../assets/New-Non-Logo.png";

const Outer = styled.div`
	display: flex;
	flex-wrap: nowrap;
	justify-content: center;
	padding: 18px 0px;
`;

const Inner = styled.div`
	display: flex;
	margin-top: -20px;
	z-index: 1;
	background: #fa7171;
	border-radius: 20px;
`;

const Image = styled.img`
	width: 15px;
	height: 15px;
`;

const Dish = ({ dish }) => {
	const cart = useSelector((state) => state.cart.value);

	const dispatch = useDispatch();
	const [quantity, setQuantity] = useState(0);
	const [show, setShow] = useState(dish.description.length > 60);

	useEffect(() => {
		let t_dish = cart.find((c) => c.id === dish.id);
		if (t_dish) setQuantity(t_dish.quantity);
		else setQuantity(0);
	}, [cart, dish]);

	const cartHandle = (mode) => {
		if (mode === "plus") dispatch(add_to_cart(dish));
		else dispatch(decrease_cart(dish));
	};
	return (
		<div className="col-9">
			<div className="food_tile active">
				<img
					src={dish.image}
					alt={dish.name}
					className="fda_product_img img_p"
				/>
				<span className="food_name">
					{dish.type === "Vegetarian" ? (
						<Image src={VegICO} alt={dish.type} />
					) : (
						<Image src={NonVegICO} alt={dish.type} />
					)}
				</span>
				<span className="food_name">{dish.name}</span>
				<span className="food_detail">
					{show ? (
						<>
							{dish.description.substring(0, 60)}...
							<button
								className="btn btn-link readm"
								style={{ display: "inline" }}
							>
								<b onClick={() => setShow(false)}>Read more</b>
							</button>
						</>
					) : (
						dish.description
					)}
				</span>
				<ul id="food_meta">
					<li>
						Price
						<span>
							<i className="fa fa-inr"></i>
							{dish.price}
						</span>
					</li>
				</ul>
				{quantity === 0 ? (
					<button
						type="button"
						className="btn btn-sm btn-default bton"
						onClick={cartHandle.bind(this, "plus")}
					>
						Add
					</button>
				) : (
					<Outer className="row">
						<Inner className="bton1">
							<button
								type="button"
								className="btn btn-sm bttn4"
								onClick={cartHandle.bind(this, "minus")}
							>
								-
							</button>
							<span className="over2">{quantity}</span>
							<button
								type="button"
								className="btn btn-sm bttn4"
								onClick={cartHandle.bind(this, "plus")}
							>
								+
							</button>
						</Inner>
					</Outer>
				)}
			</div>
		</div>
	);
};

export default Dish;
